export default "__VITE_ASSET__CjO6$UXM__"